import React, { useEffect, useState, useMemo } from "react";
import Service from "../Service/http";
import { useParams } from "react-router-dom";
import Util from "../Service/util";
import { useQuery } from "react-query";
import { Chart } from "react-google-charts";
import { ClipLoader } from "react-spinners";

import { toast } from "react-toastify";
function ChartPage({ user_id }) {
  const service = new Service();

  const getData = async () => {
    const response = await service.get(`api/user/graph/data/${user_id}`);
    const transformedData = response.result.map((row) => {
      row[0] = new Date(row[0]); // Convert date strings to Date objects
      return row;
    });
    return { sites: response.sites_array, graphData: transformedData };
    // return response;
  }
  // Fetch data using useQuery
  const { data, isLoading, isError } = useQuery(
    ["graphData", user_id], // Query key
    () => getData(),
    {
      onSuccess(json) {
        
      },
      onError(error) {
        toast.error("ERROR", error);
      },
      staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    }
  );

  const newData = useMemo(() => {
    if (data?.graphData && data?.sites?.length) {
      const header = [{ type: "date", label: "Day" }, ...data.sites];
      return [header, ...data.graphData];
    }
    return [];
  }, [data]);

  const options = {
    chart: {
      title: "Solved Problem",
    },
    height: "75vh",
    width: "70vw",

  };

  return (
    <>
      {isLoading ? (
        <div className="loader-container d-flex justify-content-center align-items-center"  >
          <ClipLoader size={50}  color="#4A90E2" loading={isLoading} />
        </div>
      ) : isError ? (
        <p>Error fetching graph data. Please try again later.</p>
      ) : newData.length > 1 ? (
        <Chart chartType="LineChart" data={newData} options={options}  />
      ) : (
        <p>No data available to display.</p>
      )}
    </>
  );
}

export default ChartPage;
